import { e } from '@frontend/shared/src/utils/e';

export class SPAListPreview extends HTMLDivElement {
  constructor() {
    super();

    this.className = 'list';
  }

  onlistremove = (id: number) => {};

  onlistload = (id: number) => {};

  init = (list: { id: number; date: number; items: { name: string; sum: number }[] }) => {
    const title = e.div({ className: 'title' }, [
      e.div({ className: 'date' }, [new Date(list.date).toLocaleString('RU-ru')]),
    ]);

    const items = e.div(
      { className: 'items' },
      list.items.map(item =>
        e.div({ className: 'item' }, [
          e.div({ className: 'name' }, [item.name]),
          e.div({ className: 'sum' }, [item.sum]),
        ])
      )
    );

    const controls = e.div({ className: 'controls' }, [
      e.button(
        {
          className: 'spa-button spa-autosize spa-red',
          onclick: () => {
            this.onlistremove(list.id);
          },
        },
        ['Удалить']
      ),
      e.button(
        {
          className: 'spa-button spa-autosize spa-blue',
          onclick: () => {
            this.onlistload(list.id);
          },
        },
        ['Загрузить']
      ),
    ]);

    this.append(title, items, controls);

    return this;
  };

  connectedCallback() {}
}

customElements.define('spa-list-preview', SPAListPreview, { extends: 'div' });
